import React from 'react';
import { render } from 'react-dom';
import TfpV2 from './TfpV2';
import "./sass/main.css"

render(<TfpV2 />, document.getElementById('root'));
